import { FilterContext } from '@finn/ua-vehicle';
import { Locale } from '@finn/ui-utils';
import { useContext } from 'react';

import { buildBreadcrumbsJsonLdAsStr, createMarkup } from '~/utils/html';

/**
 * This is a component used to display the title on PLP.
 * It wraps the basic PageTitle component and adapts to the need of PLP.
 */

const PLPBreadcrumbs = () => {
  const { breadcrumbs } = useContext(FilterContext);
  // filter breadcrumbs already contain locale in the URL
  const jsonldAsString = buildBreadcrumbsJsonLdAsStr(
    breadcrumbs,
    Locale.FAKE_DEFAULT
  );

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={createMarkup(jsonldAsString)}
    />
  );
};

export default PLPBreadcrumbs;
